var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[(_vm.accessTransaction)?_c('b-embed',{staticClass:"showBI",attrs:{"src":_vm.dashboardUrl,"frameborder":"0","allowtransparency":""}}):_c('noPermission')],1)}
var staticRenderFns = []

export { render, staticRenderFns }